import React from "react";
import Resume from "../../../resume.json";

function Footer() {
  return (
    <footer className="footer has-background-link footer_style" id="contact">
      <div style={{ paddingBottom: "20px" }}>
        <div className="columns is-mobile">
          <div className="column"></div>
          <div className="column"></div>
          <div className="column"></div>
          <div className="column"></div>
          {Resume.basics.profiles.map((value, index) => {
            return (
              <div key={index} className="column has-text-centered">
                <a
                  href={value.url}
                  target="blank"
                  className="is-hovered"
                  title={value.network}
                >
                  <span className="icon">
                    <i className={value.x_icon}></i>
                  </span>
                </a>
              </div>
            );
          })}
          <div className="column"></div>
          <div className="column"></div>
          <div className="column"></div>
          <div className="column"></div>
        </div>
      </div>
      <div className="content has-text-centered has-text-white">
        <p className="copyright copyright_text">
          &copy; Chia En Chiang 2021
        </p>
      </div>
    </footer>
  );
}

export default Footer;
